import { createSelector } from 'reselect';
import TableDefinitions from '../../../../../common/TableDefinitions';
import NotificationServiceThresholdColumns from '../../containers/NotificationServiceThresholdColumns';

export const getIsLoading = (state) => state.listing.NOTIFICATION_SERVICE_THRESHOLD.isLoading;
export const getData = TableDefinitions.NOTIFICATION_SERVICE_THRESHOLD.getDataFunction();
export const getColumns = createSelector(getData, NotificationServiceThresholdColumns);
export const getElementTypeList = (state) => state.notificationService.elementTypes;
export const getIsElementTypeListLoaded = (state) => state.notificationService.isElementTypesLoaded;
export const getEditMode = (state) => state.notificationService.editMode;
export const getEditChanges = (state) => state.notificationService.editChanges;
